import React from 'react'

const PricingPage = () => (
  <div className="post">
    <h2 className="title">Pricing</h2>
    <div className="entry">
      Bulls Scoring
      <div id="form">
        <label>300 - 349</label>
        <label>$5,600.00</label>
        <br />
        <label>350 - 380</label>
        <label>$8,000.00</label>
        <br />
        <label>381 - 400</label>
        <label>$12,000.00</label>
        <br />
        <label>401 & up</label>
        <label>Negotiable</label>
        <br />
      </div>
    </div>
    <div className="entry">
      Sheep Hunts
      <div id="form">
        <label>&nbsp;</label>
        <label>$500.00 to $1000.00</label>
        <br />
      </div>
    </div>
    <p>&nbsp;</p>
    <div className="entry">
      Elk hunts are available mid September through December.
      <br />
      Elk hunts are 3 - 4 days.
      <br />
      Sheep hunts are 1 - 2 days.
      <br />
      Packages include meals, lodging, snacks, all tags and licensing, cleaning
      and skinning of animal and transport of animal to meat packing plant.
      <br />
      If you don not harvest an animal you don’t pay. You would pay for food and
      lodging which is $150.00 per day.
      <br />
      Non hunting companion $150.00 per day.
      <br />
      We require a $1000.00 deposit on elk hunts and the balance at the time of
      harvest. Deposit will be refunded if you cancel 30 days before your hunt.
      <br />
      Not included in package - processing, taxidermy, and tips for guides and
      staff.
      <br />
    </div>
  </div>
)

export default PricingPage



// WEBPACK FOOTER //
// ./src/pages/pricing.js